import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import React from "react";

const useStyles = createStyles({
  wrapper: {
    border: `1px solid ${tokens.color.semantic.border.faint}`,
    borderRadius: tokens.radius.md,
    boxShadow: tokens.shadow.raised,
    overflow: "hidden",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    "& a": {
      color: tokens.color.semantic.text.link,
    },
    // Floor the inner table so RpiTable's OverflowX scrolls it below 920px. Flooring the card
    // instead would clip under shells with overflowX:hidden (e.g. AppPage).
    "& table": {
      minWidth: "920px",
    },
  },
  footer: {
    display: "flex",
    borderTop: `1px solid ${tokens.color.semantic.border.faint}`,
    backgroundColor: tokens.color.semantic.bg.surface,
  },
});

const TableCardContext = React.createContext<HTMLDivElement | null>(null);

/** The table card element, for row menus to collide against while staying portaled. */
export function useTableCardElement() {
  return React.useContext(TableCardContext);
}

interface RpiTableContainerProps extends React.PropsWithChildren {
  "aria-label"?: string;
  "data-testid"?: string;
  footer?: React.ReactNode;
}

export function RpiTableContainer({ children, footer, ...rest }: RpiTableContainerProps) {
  const { classes } = useStyles();
  const [card, setCard] = React.useState<HTMLDivElement | null>(null);
  return (
    <div ref={setCard} className={classes.wrapper} {...rest}>
      <TableCardContext.Provider value={card}>
        {children}
        {footer && <div className={classes.footer}>{footer}</div>}
      </TableCardContext.Provider>
    </div>
  );
}
